import React from "react"
import { useSettings } from "../editor"

export default function BackgroundColor({ setting, children }) {
  const settings = useSettings()
  const colorSetting = settings.find(s => s.name === setting)
  const backgroundColor = colorSetting?.value || "#aaaaaa"
  const msoWrap = html => "</div><!--[if mso]>" + html + "<![endif]--><div>"
  const msoStart = `
      <table height="100%" width="100%" cellpadding="0" cellspacing="0" border="0">
        <tr>
          <td valign="top" align="left" style="background-color:${backgroundColor};word-break:break-all;">`
  const msoEnd = "</td></tr></table>"

  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: msoWrap(msoStart) }} />
      <div style={{ backgroundColor }} bgcolor={backgroundColor}>
        {children}
      </div>
      <div dangerouslySetInnerHTML={{ __html: msoWrap(msoEnd) }} />
    </>
  )
}
